import React from "react";
import { useSelector } from "react-redux";
import DetailedDocument from "../../../components/PatientDiagnosisDrawer/components/documents/DetailedDocument";
import "./MyDocumentsView.scss"

export default function MyDocumentsView() {
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  return (
    <div className="my-documents-view-wrapper">
      <div className="header-name">My Documents</div>

      <DetailedDocument patientDetail={userDetail} />
    </div>
  )
}